<script>
    import lucas from '../lucas.webp';
    import arch_top from '../arch-top.svg';

    export let display = 'd-block';
</script>

<div id="get-help" class="{display}">
    <div class="row gx-0">
        <div id="lucas-benschop-foto" class="col-2 col-sm-1 col-lg-3 text-lg-end">
            <img src={lucas} alt="Lucas Benschop" width="70" height="69.16">
        </div>
        <div class="offset-1 col-9 col-sm-10 col-lg-8">
            <h2>Hulp nodig?</h2>
            <p class="small-text">Mail naar <a href="mailto:info@1848.nl">info@1848.nl</a> en wij stellen je dossiers kosteloos voor je in!</p>
        </div>
    </div>
</div>

<style lang="scss">
    #get-help {
        background-color: var(--dark-blue-color);
        background-image: url('/src/routes/app/arch-top.svg'),  url('/src/routes/app/arch-right.svg');
        background-position: -295% 100%, 260% -70%;
        background-repeat: no-repeat;
        padding: 20px 16px;
        margin-bottom: var(--margin_bottom);

        img {
            max-width: 70px;
            max-height: 70px;
        }

        h2 {
            margin-bottom: 0 !important;
            font-family: var(--font-default);
            font-size: 18px !important;
            font-weight: bold;
            line-height: 22px !important;
            color: white;
        }

        p {
            line-height: 22px !important;
            color: white;
            font-weight: 600;
            margin-bottom: 0;
        }

        .small-text, a {
            font-size: 16px;
            color: white !important;
            line-height: 20.8px !important;
            font-weight: 400 !important;
            margin-bottom: 0;
        }
    }

    @media (max-width: 1399px) {
        #get-help {
            background-position: -155% 80%, 205% -70%;
        }
    }

    @media (max-width: 1199px) {
        #get-help {
            background-position: -355% 30%, 275% -90%;
        }
    }

    @media (max-width: 991px) {
        #get-help {
            background-position: -39% 80%, 130% -60%;
        }
    }

    @media (max-width: 767px) {
        #get-help {
            background-position: -66% 80%, 150% -60%;
        }
    }

    @media (max-width: 575px) {
        #get-help {
            background-position: -73% 80%, 148% -60%;
        }
    }

    @media (max-width: 463px) {
        #get-help {
            background-position: -115% 80%, 168% -60%;
        }
    }

    @media (max-width: 400px) {
        #get-help {
            background-position: -175% 80%, 198% -60%;
        }
    }
</style>
